<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  Card,
  CardHeader,
  CardContent,
} from 'dashboard/components-next/ui-shadcn/card';

const props = defineProps({
  open: { type: Number, default: 0 },
  unattended: { type: Number, default: 0 },
  unassigned: { type: Number, default: 0 },
  pending: { type: Number, default: 0 },
});

const { t } = useI18n();

const tiles = computed(() => [
  {
    label: t('PAINEL_PRINCIPAL.QUEUE.OPEN'),
    value: props.open,
    icon: 'i-lucide-message-circle',
    accent: 'text-n-brand',
  },
  {
    label: t('PAINEL_PRINCIPAL.QUEUE.UNATTENDED'),
    value: props.unattended,
    icon: 'i-lucide-alarm-clock',
    accent: 'text-n-amber-10',
  },
  {
    label: t('PAINEL_PRINCIPAL.QUEUE.UNASSIGNED'),
    value: props.unassigned,
    icon: 'i-lucide-user-x',
    accent: 'text-n-slate-11',
  },
  {
    label: t('PAINEL_PRINCIPAL.QUEUE.PENDING'),
    value: props.pending,
    icon: 'i-lucide-hourglass',
    accent: 'text-n-teal-10',
  },
]);
</script>

<template>
  <Card>
    <CardHeader>
      <h3 class="text-base font-semibold text-n-slate-12">
        {{ t('PAINEL_PRINCIPAL.QUEUE.TITLE') }}
      </h3>
      <p class="text-xs text-n-slate-10 flex items-center gap-1.5">
        <span class="size-1.5 rounded-full bg-n-teal-9" />
        {{ t('PAINEL_PRINCIPAL.KPI.LIVE') }}
      </p>
    </CardHeader>
    <CardContent class="pt-0">
      <div class="grid grid-cols-2 gap-3">
        <div
          v-for="tile in tiles"
          :key="tile.label"
          class="rounded-xl bg-n-alpha-1 dark:bg-n-alpha-2 p-4"
        >
          <span class="size-5" :class="[tile.icon, tile.accent]" />
          <p class="text-2xl font-bold text-n-slate-12 mt-2">
            {{ tile.value }}
          </p>
          <p class="text-xs text-n-slate-10 truncate">{{ tile.label }}</p>
        </div>
      </div>
    </CardContent>
  </Card>
</template>
